import { Image, Container, Row, Col } from 'react-bootstrap';
import Sidebar from './AnimatedList';
import "./Services.css";

function AirChartering() {
    return (
        <>
            <Image className="fade-in responsive-img" src="https://windward.ai/wp-content/uploads/2025/05/shipping-logistics-featured-scaled.jpg" height={500} width="100%" fluid />
            <Container>
                <Row>
                    <Col md={8}>
                        <h1 className='text-center my-2 text-decoration-underline'><strong>Air Chartering and Freight Management</strong></h1>
                        <p style={{ fontSize: '20px' }} className='justify-text'>DELTRANS GLOBAL offers complete logistic services worldwide for each type of cargo. Whether you want to ship regular cargo, special cargo such as dangerous goods, temperature controlled goods or oversized goods, we are backed up by a large network of local agents that guarantee the transport of your goods runs smoothly. Because we are part of a group with a wide range of services, we can also offer you various one-stop solutions. We can take care of the entire logistic process for you. From the collection of your goods at the factory via our fixed road haulers for road transport, the delivery of air cargo at the airport, the complete preparation and handling of customs formalities, to the delivery of your special cargo to your doorstep. DELTRANS GLOBAL monitors the process from A to Z and will keep you informed if desired, so you can continue to focus on your most important business activities.</p>
                    </Col>
                    <Col md={4}>
                    <Sidebar/>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default AirChartering